import { getEnvFeatureFlag } from '~/utils/getEnvFeatureFlag';
import { useClientContractTermDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ClientContractTermDetailPresentation } from './presentations';

type Props = {
  /** 利用企業 ID（Screen 層でパース・検証済みの数値） */
  clientId: number;
  /** 企業契約期間 ID（Screen 層でパース・検証済みの数値） */
  termId: number;
};

/**
 * 企業契約期間 詳細 Container
 *
 * @param clientId - 利用企業 ID（Screen 層でパース・検証済みの数値）
 * @param termId - 企業契約期間 ID（Screen 層でパース・検証済みの数値）
 *
 * ## 注意
 * - Suspense（`suspense: true`）でデータ取得を行うため、エラー時は ErrorBoundary に委譲される
 * - isStagingFeatureEnabled（= getEnvFeatureFlag().enableStaging）をここで判定し、
 *   convertToPresentationProps に渡して editLink の生成を出し分ける（PEN-982）。
 *   編集機能は T04（PEN-981）で完成しているが、本番公開前の検証期間として
 *   staging / development のみ編集ボタンを表示する。
 */
export const ClientContractTermDetail: React.FC<Props> = ({ clientId, termId }) => {
  const { enableStaging: isStagingFeatureEnabled } = getEnvFeatureFlag();

  const {
    state: { data },
  } = useClientContractTermDetail({ clientId, termId });

  const {
    clientName,
    editLink,
    contractPlanName,
    contractPlanLink,
    startedOnLabel,
    endedOnLabel,
    createdAtLabel,
    updatedAtLabel,
  } = convertToPresentationProps({ data, isStagingFeatureEnabled });

  return (
    <ClientContractTermDetailPresentation
      clientName={clientName}
      editLink={editLink}
      contractPlanName={contractPlanName}
      contractPlanLink={contractPlanLink}
      startedOnLabel={startedOnLabel}
      endedOnLabel={endedOnLabel}
      createdAtLabel={createdAtLabel}
      updatedAtLabel={updatedAtLabel}
    />
  );
};
